import './PersonalIdentifier.css';
import React, { useState } from 'react';
import classnames from 'classnames';
import { t } from '../../locales/translate';
import { Modal } from '../Modal/Modal';
import { Button } from '../Button/Button';
import { joinJsonValues } from '../../util/util';
import { Icon } from '../Icon/Icon';
import { ControlledModal } from '../Modal/ControlledModal';
import { PersonalIdentifierModal } from '../../pages/ticketing/Orders/modals/PersonalIdentifierModal';

interface Props {
  value?: string | null;
  edit?: {
    orderId: string;
    itemId: string;
  };
}

export function PersonalIdentifier({ value, edit }: Props): JSX.Element | null {
  const [modal, setModal] = useState<'display' | 'edit' | null>(null);

  let text = value;
  let json: Record<string, unknown> | null = null;

  try {
    json = JSON.parse(value ?? '');
    text = joinJsonValues(value ?? '');
  } catch {
    // ignore
  }

  return (
    <>
      <div
        className={classnames('personal-identifier', {
          'personal-identifier--multiline': json,
          'personal-identifier--plain': !json,
        })}
      >
        <div className="personal-identifier__content">{text}</div>
        <div className="personal-identifier__actions">
          {json && <Icon tooltip={t.general.seeMore} name="debug--sm" onClick={() => setModal('display')} />}
          {edit && <Icon tooltip={t.actions.edit('')} name="edit--sm" onClick={() => setModal('edit')} />}
        </div>
      </div>
      <Modal
        open={modal === 'display'}
        title={<div className="color-text">{t.model.ticket.personalIdentifier}</div>}
        footer={<Button title={t.actions.close('')} onClick={() => setModal(null)} />}
      >
        <pre>{JSON.stringify(json, null, 2)}</pre>
      </Modal>
      <ControlledModal<{ personalIdentifier?: string | null }>
        open={modal === 'edit'}
        onClose={() => {
          setModal(null);
        }}
        title={t.model.ticket.updatePersonalIdentifier}
        size="small"
        model={{ personalIdentifier: value }}
      >
        {(controller) =>
          edit && <PersonalIdentifierModal orderId={edit.orderId} itemId={edit.itemId} controller={controller} />
        }
      </ControlledModal>
    </>
  );
}
